import {blue, gold, green, lime, magenta, orange, purple, red, volcano} from '@ant-design/colors';

/**
 * Color Design Tokens
 * Mirrors colors.module.css structure
 *
 * NOTE: The gray scale uses Ant Design's standard neutral palette values.
 * These are hardcoded because @ant-design/colors doesn't export neutral grays.
 * Values match Ant Design v4/v5 neutral-1 through neutral-13.
 */

const addAlpha = (hexColor, alpha) => {
  const redChannel = parseInt(hexColor.slice(1, 3), 16);
  const greenChannel = parseInt(hexColor.slice(3, 5), 16);
  const blueChannel = parseInt(hexColor.slice(5, 7), 16);
  return `rgba(${redChannel}, ${greenChannel}, ${blueChannel}, ${alpha})`;
};

export const colors = {
  // Standard Ant Design neutral palette (not exported by @ant-design/colors)
  gray10: '#000000', // neutral-13
  gray9: '#262626', // neutral-10
  gray8: '#595959', // neutral-8
  gray7: '#8C8C8C', // neutral-7
  gray6: '#BFBFBF', // neutral-6
  gray5: '#D9D9D9', // neutral-5
  gray4: '#F0F0F0', // neutral-4
  gray3: '#F5F5F5', // neutral-3
  gray2: '#FAFAFA', // neutral-2
  gray1: '#FFFFFF', // neutral-1
  gray1A65: '#ffffffa6', // neutral-1 with 65% opacity

  primaryBlue: blue.primary,
  daybreakBlue1: blue[0],
  daybreakBlue3: blue[2],
  daybreakBlue5: blue[4],
  daybreakBlue6: blue[5],

  ratingExtreme: red[5],
  ratingHigh: orange[5],
  ratingModerate: gold[5],
  ratingLow: lime[5],
  ratingMinimal: green[5],
  ratingUnrated: '#D9D9D9', // matches --rating-unrated in colors.module.css

  categoricalBlue: blue[5],
  categoricalPurple: purple[5],
  categoricalBurgundy: magenta[7],
  categoricalRed: red[5],
  categoricalRed6: red[7],
  categoricalRed7: red[8],
  categoricalOrange: volcano[5],
  categoricalYellow: gold[7],
  categoricalTan: gold[4],
  categoricalPink: volcano[2],
  categoricalGreen: green[8],
  categoricalGreen1: lime[5],
  categoricalGreen6: green[7],
  categoricalGreen8: green[9],
  categoricalGold9: gold[10],

  severityCritical: red[7],
  severityWarning: orange[7],
  severityCaution: gold[6],
  severityInformational: green[7],
  severityPotential: '#000000',

  borderBlue: addAlpha(blue[5], 0.6),
  borderPurple: addAlpha(purple[6], 0.6),
  borderMaroon: addAlpha(magenta[6], 0.6),
  borderRed: addAlpha(red[6], 0.6),
  borderSpanishOrange: addAlpha(orange[6], 0.6),
  borderWebOrange: addAlpha(gold[6], 0.6),
  borderApricot: addAlpha(gold[3], 0.6),

  desktopAlertGreen: green[7],
  desktopAlertYellow: gold[3],
  desktopAlertRed: red[6],

  transparent: 'transparent',
  antdDanger: red[2],
  magenta7: magenta[8],
  dustRed1: red[0],
  dustRed3: red[2],
  alertWarningBorder: gold[2],
  daybreakBlueBorder: blue[1],
};
